// Ticket request forms, Ticket Codes and the public ticket reply page — the screens' strings in the portal's four
// languages (2026-10-21). The form's own field labels and titles come from the database (label / labelKo) and are
// not here; neither are the ticket mail's EN + KO halves, which are written for the recipients, not the reader.
const en = {
  // The per-code request block on a ticket card (TicketFormFields)
  missingOneSku: 'at least one SKU',
  missingSkuLine: '{{sku}} line {{n}}',
  pickOrType: 'pick or type — separate with commas',
  notFixedList: 'not yet a fixed list — type the value',
  yes: 'Yes',
  no: 'No',
  numberOrUnknown: 'number or {{word}}',
  skusCovered: 'SKUs this ticket covers',
  tickedCount: '{{n}} of {{total}} ticked',
  alreadyAskedFor: '{{n}} already asked for',
  tickAll: 'Tick all SKUs',
  fillDownTitle: 'Copy "{{value}}" from {{sku}} down to all {{n}} ticked SKUs',
  fillNeedTwo: 'Tick at least two SKUs first',
  fillNeedFirst: 'Fill the first ticked SKU’s cell first',
  fillDownAria: 'Fill {{label}} down the column',
  materialsNote: '{{n}} material(s) — tick the ones to source',
  materialN: 'material {{n}}',
  lineN: '↳ line {{n}}',
  takenOn: 'on {{ticket}}',
  alreadyOn: 'Already on {{ticket}}',
  removeLine: 'Remove this line',
  addLine: 'Another line for this SKU — a second colourway, say',
  noSkuInGroup: 'This project group has no SKU yet.',

  // Request forms admin (TicketFormsAdmin)
  admLoadFailed: 'Could not load the forms',
  admSaveFailed: 'Could not save',
  admFormSaved: 'Form saved',
  admSharedSaved: 'Header and footer saved — every code uses these',
  admLoading: 'Loading…',
  admRequestForm: 'Request form',
  admUsedBy: 'Used by',
  admNoCodeYet: 'no code yet',
  admSaveForm: 'Save form',
  admBlockHeading: 'Block heading',
  admEmailBlock: 'Email block — each of these tokens is replaced by what the requester typed:',
  admFieldsAsked: 'Fields asked on the ticket',
  admAddField: 'Add field',
  admColFieldKey: 'Field key',
  admColLabel: 'Label on the form',
  admColType: 'Type',
  admColRequired: 'Required',
  admColOptions: 'Options (separated by /)',
  admColOrder: 'Order',
  admOptionsPh: 'Proto / Counter / Fit — leave empty and it stays a free text box',
  admSharedHead: 'Header and footer — shared by every ticket code',
  admSaveShared: 'Save header and footer',
  admHeader: 'Header',
  admFooter: 'Footer',
  admHeaderKo: 'Header — 한국어',
  admFooterKo: 'Footer — 한국어',
  admKoEmptyPh: 'Leave empty and the mail stays English-only',

  // Ticket Codes (25_TicketCodes)
  codesSearchFilter: 'Search: {{q}}',
  requestFailed: 'Request failed ({{status}})',
  exportFailedStatus: 'Export failed ({{status}})',
  codesNoMatch: 'No ticket code matches.',
  codesExportTitle: 'HEVN - {{title}}',

  // The public ticket reply page (17_TaskStatus)
  pageTitle: 'Helinox · Ticket Update',
  loadingTicket: 'Loading ticket…',
  invalidLink: 'Invalid or expired ticket link.',
  updateFailed: 'Unable to update ticket',
  projectAssigned: 'Project: {{project}}  |  Assigned to: {{assignee}}',
  dueOn: 'Due: {{date}}',
  description: 'Description',
  emailContent: 'Ticket email content',
  attachment: 'Attachment',
  openAttachment: 'Open attachment',
  noteFromRequester: 'Note from the requester',
  updatedOk: '✓ Status updated successfully. Thank you!',
  alreadyMarked: '✓ This ticket is already marked as <b>{{status}}</b>.',
  noFurtherAction: 'No further action needed.',
  yourName: 'Your name',
  yourNameHint: 'The person who raised this ticket will see this name, so they know who answered.',
  yourNamePh: 'e.g. Sanghyun Kim',
  reportStatus: 'Report status',
  reportStatusHint: 'This is your report back to the requesting team. The ticket’s official status stays with whoever raised it.',
  whyCancelled: 'Why is it cancelled?',
  noteOptional: 'Your note (optional)',
  cancelHint: '“Cancelled” on its own does not say whether the sample is dropped, replaced or simply no longer needed — say which, so nobody has to write back and ask.',
  cancelPh: 'e.g. the buyer dropped the style — no further sample needed',
  notePh: 'Add a note…',
  needReason: 'Please say why it is cancelled',
  needName: 'Please type your name first',
  needNameBelow: 'Please type your name above before submitting.',
  needReasonBelow: 'Please say why it is cancelled before submitting.',
  submitting: 'Submitting…',
  submit: 'Submit Update',
  // The receiving team's four answers — DISPLAY labels only; the value posted stays the English word.
  asNotStarted: 'Not started',
  asInProgress: 'In Progress',
  asDone: 'Done',
  asCancelled: 'Cancelled',
};

const ko = {
  missingOneSku: 'SKU 최소 1개',
  missingSkuLine: '{{sku}} {{n}}번째 줄',
  pickOrType: '선택하거나 입력 — 쉼표로 구분',
  notFixedList: '아직 정해진 목록이 없음 — 값을 입력하세요',
  yes: '예',
  no: '아니오',
  numberOrUnknown: '숫자 또는 {{word}}',
  skusCovered: '이 티켓에 포함된 SKU',
  tickedCount: '{{total}}개 중 {{n}}개 선택',
  alreadyAskedFor: '{{n}}개는 이미 요청됨',
  tickAll: 'SKU 전체 선택',
  fillDownTitle: '{{sku}}의 "{{value}}" 값을 선택된 SKU {{n}}개 전체에 복사',
  fillNeedTwo: '먼저 SKU를 2개 이상 선택하세요',
  fillNeedFirst: '먼저 첫 번째로 선택한 SKU의 칸을 채우세요',
  fillDownAria: '{{label}} 열 아래로 채우기',
  materialsNote: '자재 {{n}}개 — 소싱할 자재를 선택하세요',
  materialN: '자재 {{n}}',
  lineN: '↳ {{n}}번째 줄',
  takenOn: '{{ticket}}에 있음',
  alreadyOn: '이미 {{ticket}}에 있음',
  removeLine: '이 줄 삭제',
  addLine: '이 SKU에 줄 추가 — 예: 두 번째 컬러웨이',
  noSkuInGroup: '이 프로젝트 그룹에는 아직 SKU가 없습니다.',

  admLoadFailed: '양식을 불러오지 못했습니다',
  admSaveFailed: '저장하지 못했습니다',
  admFormSaved: '양식을 저장했습니다',
  admSharedSaved: '머리글과 바닥글을 저장했습니다 — 모든 코드에 적용됩니다',
  admLoading: '불러오는 중…',
  admRequestForm: '요청 양식',
  admUsedBy: '사용 코드',
  admNoCodeYet: '아직 코드 없음',
  admSaveForm: '양식 저장',
  admBlockHeading: '블록 제목',
  admEmailBlock: '메일 블록 — 아래 토큰은 요청자가 입력한 내용으로 바뀝니다:',
  admFieldsAsked: '티켓에서 묻는 항목',
  admAddField: '항목 추가',
  admColFieldKey: '항목 키',
  admColLabel: '양식에 표시되는 이름',
  admColType: '유형',
  admColRequired: '필수',
  admColOptions: '선택지 (/로 구분)',
  admColOrder: '순서',
  admOptionsPh: 'Proto / Counter / Fit — 비워 두면 자유 입력 칸으로 남습니다',
  admSharedHead: '머리글과 바닥글 — 모든 티켓 코드 공통',
  admSaveShared: '머리글과 바닥글 저장',
  admHeader: '머리글',
  admFooter: '바닥글',
  admHeaderKo: '머리글 — 한국어',
  admFooterKo: '바닥글 — 한국어',
  admKoEmptyPh: '비워 두면 메일은 영어로만 나갑니다',

  codesSearchFilter: '검색: {{q}}',
  requestFailed: '요청 실패 ({{status}})',
  exportFailedStatus: '내보내기 실패 ({{status}})',
  codesNoMatch: '일치하는 티켓 코드가 없습니다.',
  codesExportTitle: 'HEVN - {{title}}',

  pageTitle: 'Helinox · 티켓 업데이트',
  loadingTicket: '티켓을 불러오는 중…',
  invalidLink: '유효하지 않거나 만료된 티켓 링크입니다.',
  updateFailed: '티켓을 업데이트하지 못했습니다',
  projectAssigned: '프로젝트: {{project}}  |  담당: {{assignee}}',
  dueOn: '기한: {{date}}',
  description: '설명',
  emailContent: '티켓 메일 내용',
  attachment: '첨부',
  openAttachment: '첨부 열기',
  noteFromRequester: '요청자 메모',
  updatedOk: '✓ 상태가 업데이트되었습니다. 감사합니다!',
  alreadyMarked: '✓ 이 티켓은 이미 <b>{{status}}</b> 상태입니다.',
  noFurtherAction: '추가 조치가 필요 없습니다.',
  yourName: '이름',
  yourNameHint: '이 티켓을 요청한 사람이 이 이름을 보고 누가 회신했는지 알 수 있습니다.',
  yourNamePh: '예: Sanghyun Kim',
  reportStatus: '진행 상태 회신',
  reportStatusHint: '요청 팀에 보내는 회신입니다. 티켓의 공식 상태는 티켓을 요청한 사람이 관리합니다.',
  whyCancelled: '취소 사유는 무엇입니까?',
  noteOptional: '메모 (선택)',
  cancelHint: '“취소됨”만으로는 샘플이 드롭된 것인지, 대체된 것인지, 더 이상 필요 없는 것인지 알 수 없습니다 — 다시 묻지 않도록 어느 쪽인지 적어 주세요.',
  cancelPh: '예: 바이어가 스타일을 드롭함 — 추가 샘플 불필요',
  notePh: '메모 추가…',
  needReason: '취소 사유를 적어 주세요',
  needName: '먼저 이름을 입력하세요',
  needNameBelow: '제출하기 전에 위에 이름을 입력하세요.',
  needReasonBelow: '제출하기 전에 취소 사유를 적어 주세요.',
  submitting: '제출 중…',
  submit: '업데이트 제출',
  asNotStarted: '시작 전',
  asInProgress: '진행 중',
  asDone: '완료',
  asCancelled: '취소됨',
};

const vi = {
  missingOneSku: 'ít nhất một SKU',
  missingSkuLine: '{{sku}} dòng {{n}}',
  pickOrType: 'chọn hoặc gõ — phân cách bằng dấu phẩy',
  notFixedList: 'chưa có danh sách cố định — hãy gõ giá trị',
  yes: 'Có',
  no: 'Không',
  numberOrUnknown: 'số hoặc {{word}}',
  skusCovered: 'Các SKU thuộc ticket này',
  tickedCount: 'Đã chọn {{n}}/{{total}}',
  alreadyAskedFor: '{{n}} SKU đã được yêu cầu',
  tickAll: 'Chọn tất cả SKU',
  fillDownTitle: 'Chép "{{value}}" từ {{sku}} xuống cả {{n}} SKU đã chọn',
  fillNeedTwo: 'Hãy chọn ít nhất hai SKU trước',
  fillNeedFirst: 'Hãy điền ô của SKU được chọn đầu tiên trước',
  fillDownAria: 'Điền {{label}} xuống cả cột',
  materialsNote: '{{n}} nguyên liệu — tích chọn những nguyên liệu cần tìm nguồn',
  materialN: 'nguyên liệu {{n}}',
  lineN: '↳ dòng {{n}}',
  takenOn: 'thuộc {{ticket}}',
  alreadyOn: 'Đã có trong {{ticket}}',
  removeLine: 'Xóa dòng này',
  addLine: 'Thêm một dòng cho SKU này — ví dụ một màu thứ hai',
  noSkuInGroup: 'Nhóm dự án này chưa có SKU nào.',

  admLoadFailed: 'Không tải được các biểu mẫu',
  admSaveFailed: 'Không lưu được',
  admFormSaved: 'Đã lưu biểu mẫu',
  admSharedSaved: 'Đã lưu phần đầu và phần cuối thư — mọi mã đều dùng chung',
  admLoading: 'Đang tải…',
  admRequestForm: 'Biểu mẫu yêu cầu',
  admUsedBy: 'Dùng cho',
  admNoCodeYet: 'chưa có mã nào',
  admSaveForm: 'Lưu biểu mẫu',
  admBlockHeading: 'Tiêu đề khối',
  admEmailBlock: 'Khối nội dung email — mỗi token dưới đây được thay bằng nội dung người yêu cầu đã nhập:',
  admFieldsAsked: 'Các trường hỏi trên ticket',
  admAddField: 'Thêm trường',
  admColFieldKey: 'Khóa trường',
  admColLabel: 'Nhãn trên biểu mẫu',
  admColType: 'Loại',
  admColRequired: 'Bắt buộc',
  admColOptions: 'Lựa chọn (phân cách bằng /)',
  admColOrder: 'Thứ tự',
  admOptionsPh: 'Proto / Counter / Fit — để trống thì đây vẫn là ô nhập tự do',
  admSharedHead: 'Phần đầu và phần cuối thư — dùng chung cho mọi mã ticket',
  admSaveShared: 'Lưu phần đầu và phần cuối thư',
  admHeader: 'Phần đầu thư',
  admFooter: 'Phần cuối thư',
  admHeaderKo: 'Phần đầu thư — tiếng Hàn',
  admFooterKo: 'Phần cuối thư — tiếng Hàn',
  admKoEmptyPh: 'Để trống thì email chỉ có tiếng Anh',

  codesSearchFilter: 'Tìm kiếm: {{q}}',
  requestFailed: 'Yêu cầu thất bại ({{status}})',
  exportFailedStatus: 'Xuất file thất bại ({{status}})',
  codesNoMatch: 'Không có mã ticket nào khớp.',
  codesExportTitle: 'HEVN - {{title}}',

  pageTitle: 'Helinox · Cập nhật ticket',
  loadingTicket: 'Đang tải ticket…',
  invalidLink: 'Liên kết ticket không hợp lệ hoặc đã hết hạn.',
  updateFailed: 'Không cập nhật được ticket',
  projectAssigned: 'Dự án: {{project}}  |  Giao cho: {{assignee}}',
  dueOn: 'Hạn: {{date}}',
  description: 'Mô tả',
  emailContent: 'Nội dung email ticket',
  attachment: 'Tệp đính kèm',
  openAttachment: 'Mở tệp đính kèm',
  noteFromRequester: 'Ghi chú của người yêu cầu',
  updatedOk: '✓ Đã cập nhật trạng thái. Cảm ơn bạn!',
  alreadyMarked: '✓ Ticket này đã ở trạng thái <b>{{status}}</b>.',
  noFurtherAction: 'Không cần làm gì thêm.',
  yourName: 'Tên của bạn',
  yourNameHint: 'Người tạo ticket này sẽ thấy tên này để biết ai đã phản hồi.',
  yourNamePh: 'ví dụ: Sanghyun Kim',
  reportStatus: 'Báo cáo trạng thái',
  reportStatusHint: 'Đây là phản hồi của bạn gửi lại bộ phận yêu cầu. Trạng thái chính thức của ticket vẫn do người tạo ticket quyết định.',
  whyCancelled: 'Vì sao hủy?',
  noteOptional: 'Ghi chú của bạn (không bắt buộc)',
  cancelHint: 'Chỉ ghi “Đã hủy” thì không rõ mẫu bị bỏ, được thay thế hay đơn giản là không cần nữa — hãy nói rõ để không ai phải viết lại hỏi.',
  cancelPh: 'ví dụ: khách hàng đã bỏ style — không cần thêm mẫu',
  notePh: 'Thêm ghi chú…',
  needReason: 'Vui lòng ghi lý do hủy',
  needName: 'Vui lòng nhập tên của bạn trước',
  needNameBelow: 'Vui lòng nhập tên ở trên trước khi gửi.',
  needReasonBelow: 'Vui lòng ghi lý do hủy trước khi gửi.',
  submitting: 'Đang gửi…',
  submit: 'Gửi cập nhật',
  asNotStarted: 'Chưa bắt đầu',
  asInProgress: 'Đang làm',
  asDone: 'Xong',
  asCancelled: 'Đã hủy',
};

const zh = {
  missingOneSku: '至少一个 SKU',
  missingSkuLine: '{{sku}} 第 {{n}} 行',
  pickOrType: '选择或输入 — 用逗号分隔',
  notFixedList: '尚无固定列表 — 请输入值',
  yes: '是',
  no: '否',
  numberOrUnknown: '数字或 {{word}}',
  skusCovered: '本工单包含的 SKU',
  tickedCount: '已勾选 {{n}}/{{total}}',
  alreadyAskedFor: '{{n}} 个已被申请',
  tickAll: '勾选全部 SKU',
  fillDownTitle: '将 {{sku}} 的“{{value}}”复制到全部 {{n}} 个已勾选的 SKU',
  fillNeedTwo: '请先勾选至少两个 SKU',
  fillNeedFirst: '请先填写第一个已勾选 SKU 的单元格',
  fillDownAria: '向下填充 {{label}} 列',
  materialsNote: '{{n}} 种物料 — 勾选需要寻源的物料',
  materialN: '物料 {{n}}',
  lineN: '↳ 第 {{n}} 行',
  takenOn: '在 {{ticket}} 中',
  alreadyOn: '已在 {{ticket}} 中',
  removeLine: '删除此行',
  addLine: '为此 SKU 再加一行 — 例如第二个配色',
  noSkuInGroup: '此项目组还没有 SKU。',

  admLoadFailed: '无法加载表单',
  admSaveFailed: '无法保存',
  admFormSaved: '表单已保存',
  admSharedSaved: '页眉和页脚已保存 — 所有代码共用',
  admLoading: '加载中…',
  admRequestForm: '申请表单',
  admUsedBy: '使用的代码',
  admNoCodeYet: '尚无代码',
  admSaveForm: '保存表单',
  admBlockHeading: '区块标题',
  admEmailBlock: '邮件区块 — 以下每个标记都会替换为申请人填写的内容：',
  admFieldsAsked: '工单中询问的字段',
  admAddField: '添加字段',
  admColFieldKey: '字段键',
  admColLabel: '表单上的标签',
  admColType: '类型',
  admColRequired: '必填',
  admColOptions: '选项（用 / 分隔）',
  admColOrder: '顺序',
  admOptionsPh: 'Proto / Counter / Fit — 留空则保持为自由输入框',
  admSharedHead: '页眉和页脚 — 所有工单代码共用',
  admSaveShared: '保存页眉和页脚',
  admHeader: '页眉',
  admFooter: '页脚',
  admHeaderKo: '页眉 — 韩语',
  admFooterKo: '页脚 — 韩语',
  admKoEmptyPh: '留空则邮件只有英文',

  codesSearchFilter: '搜索：{{q}}',
  requestFailed: '请求失败（{{status}}）',
  exportFailedStatus: '导出失败（{{status}}）',
  codesNoMatch: '没有匹配的工单代码。',
  codesExportTitle: 'HEVN - {{title}}',

  pageTitle: 'Helinox · 工单更新',
  loadingTicket: '正在加载工单…',
  invalidLink: '工单链接无效或已过期。',
  updateFailed: '无法更新工单',
  projectAssigned: '项目：{{project}}  |  指派给：{{assignee}}',
  dueOn: '期限：{{date}}',
  description: '描述',
  emailContent: '工单邮件内容',
  attachment: '附件',
  openAttachment: '打开附件',
  noteFromRequester: '申请人备注',
  updatedOk: '✓ 状态已更新。谢谢！',
  alreadyMarked: '✓ 此工单已标记为 <b>{{status}}</b>。',
  noFurtherAction: '无需进一步操作。',
  yourName: '您的姓名',
  yourNameHint: '创建此工单的人会看到这个名字，从而知道是谁回复的。',
  yourNamePh: '例如：Sanghyun Kim',
  reportStatus: '回报状态',
  reportStatusHint: '这是您回复给申请团队的报告。工单的正式状态仍由创建工单的人决定。',
  whyCancelled: '为什么取消？',
  noteOptional: '您的备注（选填）',
  cancelHint: '只写“已取消”无法说明样品是被放弃、被替换，还是不再需要 — 请说明是哪一种，免得对方还要回信询问。',
  cancelPh: '例如：客户放弃了该款式 — 无需再做样品',
  notePh: '添加备注…',
  needReason: '请说明取消原因',
  needName: '请先输入您的姓名',
  needNameBelow: '提交前请在上方输入您的姓名。',
  needReasonBelow: '提交前请说明取消原因。',
  submitting: '提交中…',
  submit: '提交更新',
  asNotStarted: '未开始',
  asInProgress: '进行中',
  asDone: '已完成',
  asCancelled: '已取消',
};

const dictionary = { ns: 'xTicket', en, ko, vi, zh };

export default dictionary;
